export class ErrorRequestPageRequest {
    public urlRequest: string;
    public datetimeRequest: Date;
}